import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import HiddenByApplicant from 'src/components/ResumeCard/HiddenByApplicant';
import translation from 'src/components/translation';

const TrlKeys = {
    hidden: 'resume.hiddenFields.name',
};

interface Props {
    fullName: string | null;
    isHiddenByApplicant: boolean;
}

const FullName: TranslatedComponent<Props> = ({ fullName, isHiddenByApplicant, trls }) => {
    return (
        <span data-qa="resume-serp__resume-fullname">
            {!isHiddenByApplicant ? fullName : <HiddenByApplicant>{trls[TrlKeys.hidden]}</HiddenByApplicant>}
        </span>
    );
};

export default translation(FullName);
